import { api_request } from "api";
import axios from "axios";
//import axiosRetry from "axios-retry";

export const authAPIRequest = () => {
  const _axios = new axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/partners`,
    timeout: 60000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return _axios;
};

export const partners_auth = async (payload) => {
  return new Promise((resolve, reject) => {
    authAPIRequest()
      .post("/auth", payload)
      .then((res) => resolve(res))
      .catch((err) => {
        reject({ ...err });
      });
  });
};

export const partners_auth_confirm = async (payload) => {
  return new Promise((resolve, reject) => {
    authAPIRequest()
      .post("/auth/confirm", payload)
      .then((res) => resolve(res))
      .catch((err) => {
        reject({ ...err });
      });
  });
};

export const partners_auth_verify = async (payload) => {
  return new Promise((resolve, reject) => {
    authAPIRequest()
      .get("/auth/verify", {
        headers: {
          user: payload._id,
          token: payload.token,
        },
      })
      .then((res) => resolve(res))
      .catch((err) => {
        reject({ ...err });
      });
  });
};

export const change_password = async (payload) => {
  return new Promise((resolve, reject) => {
    api_request()
      .post("/auth/change-password", payload)
      .then((res) => resolve(res))
      .catch((err) => {
        reject({ ...err });
      });
  });
};
